import { VIEWER_ROUTE } from '../../config/appRoutes';

const getLinkToViewer = (fileId: string): string => `${window.location.origin}${VIEWER_ROUTE}/${fileId}`;

export default getLinkToViewer;
